import { useCRUDList } from '@/shared/hooks/useCRUDList';
import { inspectorUserService } from '@/services/inspectorUser.service';
import type { InspectorUser } from '@/services/types/user.types';

const inspectorUserServiceAdapter = {
  getAll: () => inspectorUserService.getAllInspectorUsers(),
  delete: (id: string) => inspectorUserService.deleteInspectorUser(id),
};

export function useInspectorUserList() {
  const {
    items: inspectorUsers,
    loading,
    handleNew,
    handleEdit,
    handleDelete,
  } = useCRUDList<InspectorUser>({
    service: inspectorUserServiceAdapter,
    entityName: 'usuário inspetor',
    routes: {
      new: '/inspector-register',
      edit: (id) => `/inspector-edit/${id}`,
    },
    messages: {
      loadError: 'Erro ao carregar usuários inspetores',
      deleteSuccess: 'Usuário excluído com sucesso!',
      deleteError: 'Erro ao excluir usuário',
    },
  });

  const columns = [
    { key: 'name', title: 'Nome', dataIndex: 'name' },
    { key: 'email', title: 'Email', dataIndex: 'email' },
    { key: 'phoneNumber', title: 'Telefone', dataIndex: 'phoneNumber' },
    { key: 'cpf', title: 'CPF', dataIndex: 'cpf' },
    { key: 'providerName', title: 'Prestadora', dataIndex: 'providerName' },
  ];

  return {
    inspectorUsers,
    loading,
    columns,
    handleNew,
    handleEdit,
    handleDelete,
  };
}
